/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConBrandWebControllerV1BusinessCapacityUsingGet1Params,
  ConBrandWebControllerV1CompareSelectUsingGet1Params,
  ConBrandWebControllerV1FindUsingGet1Params,
  ConBrandWebControllerV1IndexDataUsingGet1Params,
  ConBrandWebControllerV1ListUsingGet1Params,
  ConBrandWebControllerV1MarketingCapacityUsingGet1Params,
  ConBrandWebControllerV1SearchUsingGet1Params,
  ConBrandWebControllerV1SupplyChainUsingGet1Params,
  ConBrandWebControllerV1TrackBrandPotentialUsingGet1Params,
  ConBrandWebControllerV1UserBrandAuthUsingGet1Params,
  ResultConBrandWebV1BrandCountResponse,
  ResultConBrandWebV1BusinessCapacityResponse,
  ResultConBrandWebV1FindResponse,
  ResultConBrandWebV1IndexDataResponse,
  ResultConBrandWebV1MarketResponse,
  ResultConBrandWebV1PotentialResponse,
  ResultConBrandWebV1SupplyChainResponse,
  ResultMemberBrandAuth,
  ResultPageResultConBrandWebV1ListResponse,
  ResultTotalListResponseConBrandWebV1SelectResponse,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class ConBrandWebController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1ListUsingGet1
   * @summary 品牌库-筛选列表
   * @request GET:/consumebrand/web/v1/conbrand
   * @secure
   */
  conBrandWebControllerV1ListUsingGet1 = (
    query: ConBrandWebControllerV1ListUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultPageResultConBrandWebV1ListResponse, void>({
      path: `/consumebrand/web/v1/conbrand`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1BrandCountUsingGet1
   * @summary 品牌总数
   * @request GET:/consumebrand/web/v1/conbrand/brand_count
   * @secure
   */
  conBrandWebControllerV1BrandCountUsingGet1 = (params: RequestParams = {}) =>
    this.request<ResultConBrandWebV1BrandCountResponse, void>({
      path: `/consumebrand/web/v1/conbrand/brand_count`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1CompareSelectUsingGet1
   * @summary 对比:模糊查询品牌下拉, 带是否解锁标记
   * @request GET:/consumebrand/web/v1/conbrand/compare_select
   * @secure
   */
  conBrandWebControllerV1CompareSelectUsingGet1 = (
    query: ConBrandWebControllerV1CompareSelectUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultTotalListResponseConBrandWebV1SelectResponse, void>({
      path: `/consumebrand/web/v1/conbrand/compare_select`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1SearchUsingGet1
   * @summary 品牌库-搜索
   * @request GET:/consumebrand/web/v1/conbrand/search
   * @secure
   */
  conBrandWebControllerV1SearchUsingGet1 = (
    query: ConBrandWebControllerV1SearchUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultPageResultConBrandWebV1ListResponse, void>({
      path: `/consumebrand/web/v1/conbrand/search`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1UserBrandAuthUsingGet1
   * @summary 品牌详情-用户对于该品牌的权限信息
   * @request GET:/consumebrand/web/v1/conbrand/user_brand_auth
   * @secure
   */
  conBrandWebControllerV1UserBrandAuthUsingGet1 = (
    query: ConBrandWebControllerV1UserBrandAuthUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultMemberBrandAuth, void>({
      path: `/consumebrand/web/v1/conbrand/user_brand_auth`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1FindUsingGet1
   * @summary 品牌详情-基本信息
   * @request GET:/consumebrand/web/v1/conbrand/{conBrandId}
   * @secure
   */
  conBrandWebControllerV1FindUsingGet1 = (
    { conBrandId, ...query }: ConBrandWebControllerV1FindUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultConBrandWebV1FindResponse, void>({
      path: `/consumebrand/web/v1/conbrand/${conBrandId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1BusinessCapacityUsingGet1
   * @summary 品牌详情-经营能力(经营规模&非大促销销售额占比)
   * @request GET:/consumebrand/web/v1/conbrand/{conBrandId}/business_capacity
   * @secure
   */
  conBrandWebControllerV1BusinessCapacityUsingGet1 = (
    { conBrandId, ...query }: ConBrandWebControllerV1BusinessCapacityUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultConBrandWebV1BusinessCapacityResponse, void>({
      path: `/consumebrand/web/v1/conbrand/${conBrandId}/business_capacity`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1IndexDataUsingGet1
   * @summary 品牌详情-品牌综合指数(指数增长情况&8大指数)
   * @request GET:/consumebrand/web/v1/conbrand/{conBrandId}/index_data
   * @secure
   */
  conBrandWebControllerV1IndexDataUsingGet1 = (
    { conBrandId, ...query }: ConBrandWebControllerV1IndexDataUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultConBrandWebV1IndexDataResponse, void>({
      path: `/consumebrand/web/v1/conbrand/${conBrandId}/index_data`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1MarketingCapacityUsingGet1
   * @summary 品牌详情-营销能力(品牌官方账号内容互动量&品牌内容生产能力&平台相关内容)
   * @request GET:/consumebrand/web/v1/conbrand/{conBrandId}/marketing_capacity
   * @secure
   */
  conBrandWebControllerV1MarketingCapacityUsingGet1 = (
    { conBrandId, ...query }: ConBrandWebControllerV1MarketingCapacityUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultConBrandWebV1MarketResponse, void>({
      path: `/consumebrand/web/v1/conbrand/${conBrandId}/marketing_capacity`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1TrackBrandPotentialUsingGet1
   * @summary 品牌详情-赛道及品牌潜力(品牌融资环境&融资历程&行业成长空间&行业及品牌讨论热度)
   * @request GET:/consumebrand/web/v1/conbrand/{conBrandId}/potential
   * @secure
   */
  conBrandWebControllerV1TrackBrandPotentialUsingGet1 = (
    { conBrandId, ...query }: ConBrandWebControllerV1TrackBrandPotentialUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultConBrandWebV1PotentialResponse, void>({
      path: `/consumebrand/web/v1/conbrand/${conBrandId}/potential`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-brand-web-controller
   * @name ConBrandWebControllerV1SupplyChainUsingGet1
   * @summary 品牌详情-供应链管理能力(供应链完善度&物流配送效率)
   * @request GET:/consumebrand/web/v1/conbrand/{conBrandId}/supply_chain
   * @secure
   */
  conBrandWebControllerV1SupplyChainUsingGet1 = (
    { conBrandId, ...query }: ConBrandWebControllerV1SupplyChainUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultConBrandWebV1SupplyChainResponse, void>({
      path: `/consumebrand/web/v1/conbrand/${conBrandId}/supply_chain`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
